import { Controller, useForm } from "react-hook-form";
import { InicialPageSearchProps } from "./inicial-page-search-props";
import { Box, Button, ButtonGroup, Grid } from "@material-ui/core";
import { useSearchBarStyles } from "./serch-bar-styles";
import { useCallback, useEffect, useState } from "react";
import { SelectSaurus } from "views/components/controles/selects/select-saurus/select-saurus";
import { TipoFiltroDataMock } from "data/mocks/tipo-data-mock";
import { StatusBoletoMock } from "data/mocks/status-boleto-mock";
import { TextFieldSaurus } from "views/components/controles/inputs";
import { PesquisaIcon } from "views/components/icons/pesquisa-icon";
import { ButtonSwitch } from "views/components/controles/buttons/button-switch/button-switch";
import { ArquivoRegistroMock } from "data/mocks/arquivo-registro-mock";
import { EnumArquivoRegistro } from "model/enums/enum-arquivo-registro";
import { useHistory } from "react-router-dom";
import { useThemeQueries } from "views/theme";
import { ExpandIcon, FiltroIcon } from "views/components/icons";
import { useInicialSearchBarValidation } from "./inicial-search-bar-validation";
import { yupResolver } from "@hookform/resolvers/yup";
import { SetaCimaIcon } from "views/components/icons/seta-cima-icon";

interface InicialPageSearchBarProps {
    setSearchProps: React.Dispatch<React.SetStateAction<InicialPageSearchProps>>;
    setSelectedPage: React.Dispatch<React.SetStateAction<EnumArquivoRegistro>>;
    selectedPage: EnumArquivoRegistro;
}

export const InicialPageSearchBar = ({
    setSearchProps,
    setSelectedPage,
    selectedPage
}: InicialPageSearchBarProps) => {

    const { isMobile } = useThemeQueries();
    const { InicialSearchBarValidation } = useInicialSearchBarValidation();

    // controla a visibilidade geral da área (em mobile fecha/abre tudo)
    const [openned, setOpenned] = useState<boolean>(!isMobile);
    // controla apenas os campos avançados (3 campos da aba boleto)
    const [advancedOpen, setAdvancedOpen] = useState<boolean>(false);

    useEffect(() => {
        if (isMobile) {
            setOpenned(false); // mobile inicia fechado por padrão
            setAdvancedOpen(false);
        } else {
            setOpenned(true); // desktop: área principal visível
            setAdvancedOpen(false); // mas avançados vêm fechados conforme solicitado
        }
    }, [isMobile]);

    // showFilters controla renderização dos campos básicos
    const showFilters = !isMobile || openned;

    const classes = useSearchBarStyles({
        openned,
        padding: 'small',
        selectedPage
    });

    const { push } = useHistory();

    const {
        handleSubmit,
        control,
        formState: { errors },
        setValue,
    } = useForm<InicialPageSearchProps>({
        defaultValues: { ...new InicialPageSearchProps() },
        resolver: yupResolver(InicialSearchBarValidation),
        criteriaMode: 'all',
        mode: 'onSubmit',
    });

    const onSubmit = useCallback((model: InicialPageSearchProps) => {
        setSearchProps({ ...model })
    }, [setSearchProps]);

    // Toggle unificado: no mobile fecha/abre TUDO (campos + buscar + buttonSwitch).
    // No desktop alterna apenas os campos avançados.
    const handleToggleFilters = () => {
        if (isMobile) {
            setOpenned(prev => {
                const next = !prev;
                setAdvancedOpen(next); // os avançados acompanham o estado mobile
                return next;
            });
        } else {
            setAdvancedOpen(prev => !prev);
        }
    };

    return (
        <>
            <Box className={classes.bar}>

                {isMobile && !openned ? (
                    <Box className={classes.closeOpenBar} onClick={() => handleToggleFilters()}>
                        <ExpandIcon tipo='GERAL' />
                        Abrir Filtros
                    </Box>
                ) : (
                    <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>

                        {showFilters && (
                            <Grid container spacing={2} className={classes.formGrid}>

                                {selectedPage === EnumArquivoRegistro.Boleto && < Grid item xs={12} md={3}>
                                    <Controller
                                        control={control}
                                        name="tipoData"
                                        render={({ field }) => (
                                            <SelectSaurus
                                                label='Tipo de Data'
                                                conteudo={TipoFiltroDataMock}
                                                fullWidth
                                                {...field}
                                                onChange={(e: any) => {
                                                    const valor = TipoFiltroDataMock.find(tipo => tipo.Key === e.target.value)
                                                    if (valor) {
                                                        setValue('tipoData', valor.Key)
                                                    }
                                                }}
                                                error={Boolean(errors.tipoData)}
                                                helperText={Boolean(errors.tipoData && errors.tipoData.message) ? errors.tipoData?.message : undefined}
                                            />
                                        )}
                                    />
                                </Grid>}

                                <Grid item xs={12} md={selectedPage === EnumArquivoRegistro.Boleto ? 3 : 6}>
                                    <Controller
                                        control={control}
                                        name="dataInicial"
                                        render={({ field }) => (
                                            <TextFieldSaurus
                                                label='Data Inicial'
                                                tipo='DATA'
                                                fullWidth
                                                {...field}
                                                error={Boolean(errors.dataInicial)}
                                                helperText={Boolean(errors.dataInicial && errors.dataInicial.message) ? errors.dataInicial?.message : undefined}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} md={selectedPage === EnumArquivoRegistro.Boleto ? 3 : 6}>
                                    <Controller
                                        control={control}
                                        name="dataFinal"
                                        render={({ field }) => (
                                            <TextFieldSaurus
                                                label='Data Final'
                                                tipo='DATA'
                                                fullWidth
                                                {...field}
                                                error={Boolean(errors.dataFinal)}
                                                helperText={Boolean(errors.dataFinal && errors.dataFinal.message) ? errors.dataFinal?.message : undefined}
                                            />
                                        )}
                                    />
                                </Grid>

                                {selectedPage === EnumArquivoRegistro.Boleto && <Grid item xs={12} md={3}>
                                    <Controller
                                        control={control}
                                        name="status"
                                        render={({ field }) => (
                                            <SelectSaurus
                                                label='Status'
                                                conteudo={StatusBoletoMock}
                                                fullWidth
                                                {...field}
                                                onChange={(e: any) => {
                                                    const valor = StatusBoletoMock.find(tipo => tipo.Key === e.target.value)
                                                    if (valor) {
                                                        setValue('status', valor.Key)
                                                    }
                                                }}
                                            />
                                        )}
                                    />
                                </Grid>}

                                {selectedPage === EnumArquivoRegistro.Boleto && (isMobile ? openned : advancedOpen) && (
                                    <>
                                        <Grid item xs={12} md={4}>
                                            <Controller
                                                control={control}
                                                name="nossoNumero"
                                                render={({ field }) => (
                                                    <TextFieldSaurus
                                                        label='Nº Boleto'
                                                        allowSubmit
                                                        {...field}
                                                        fullWidth
                                                        error={Boolean(errors.nossoNumero)}
                                                        helperText={Boolean(errors.nossoNumero && errors.nossoNumero.message) ? errors.nossoNumero?.message : undefined}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <Controller
                                                control={control}
                                                name="nomePagador"
                                                render={({ field }) => (
                                                    <TextFieldSaurus
                                                        label='Nome do Pagador'
                                                        allowSubmit
                                                        {...field}
                                                        fullWidth
                                                        tipo="TEXTO"
                                                        error={Boolean(errors.nomePagador)}
                                                        helperText={Boolean(errors.nomePagador && errors.nomePagador.message) ? errors.nomePagador?.message : undefined}
                                                    />
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={4}>
                                            <Controller
                                                control={control}
                                                name="documentoPagador"
                                                render={({ field }) => (
                                                    <TextFieldSaurus
                                                        label='CPF/CNPJ'
                                                        allowSubmit
                                                        {...field}
                                                        fullWidth
                                                        tipo="CNPJ_CPF"
                                                        error={Boolean(errors.documentoPagador)}
                                                        helperText={Boolean(errors.documentoPagador && errors.documentoPagador.message) ? errors.documentoPagador?.message : undefined}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                    </>
                                )}

                            </Grid>
                        )}

                        {(!isMobile || openned) && (
                            <>
                                <ButtonGroup variant="contained" color="primary" className={classes.buttonGroup}>
                                    <Button type='submit' className={classes.borderButton}>
                                        <PesquisaIcon tipo='BUTTON_PRIMARY' />
                                        Pesquisar
                                    </Button>

                                    {selectedPage === EnumArquivoRegistro.Boleto && !isMobile && (
                                        <Button onClick={handleToggleFilters}>
                                            {(advancedOpen) ? (
                                                <SetaCimaIcon class={classes.iconsAction} tipo="BUTTON_PRIMARY" />
                                            ) : (
                                                <FiltroIcon class={classes.iconsAction} tipo="BUTTON_PRIMARY" />
                                            )}
                                        </Button>
                                    )}
                                </ButtonGroup>

                                <Box className={classes.btnSwitchContainer}>
                                    <ButtonSwitch
                                        conteudo={ArquivoRegistroMock}
                                        defaultSelected={selectedPage}
                                        onChange={(valor) => {
                                            setSelectedPage(valor)
                                            switch (valor) {
                                                case EnumArquivoRegistro.Historico:
                                                    push('/inicial/historico');
                                                    break;
                                                case EnumArquivoRegistro.Remessa:
                                                    push('/inicial/remessa')
                                                    break;
                                                default:
                                                    push('/inicial/boletos')
                                            }
                                        }}
                                    />
                                </Box>
                            </>
                        )}
                    </form>

                )}

            </Box>

            {isMobile && openned && (
                <Box className={classes.closeOpenBar} onClick={() => handleToggleFilters()}>
                    <ExpandIcon tipo='GERAL' />
                    Fechar Filtros
                </Box>
            )}
        </>
    )
}
